import { useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

export default function CompareSlider({ before, after, beforeLabel, afterLabel }) {
  const [v, setV] = useState(50);
  return (
    <div data-testid="compare-slider">
      <div className="relative aspect-[4/3] select-none overflow-hidden rounded-2xl border border-hairline shadow-xl">
        <img
          src={before}
          alt={beforeLabel}
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
          decoding="async"
          data-testid="compare-slider-before-image"
        />
        <img
          src={after}
          alt={afterLabel}
          className="absolute inset-0 h-full w-full object-cover"
          style={{ clipPath: `inset(0 0 0 ${v}%)` }}
          loading="lazy"
          decoding="async"
          data-testid="compare-slider-after-image"
        />
        <span className="pointer-events-none absolute left-4 top-4 rounded-full bg-ink/70 px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-cream backdrop-blur">
          {beforeLabel}
        </span>
        <span className="pointer-events-none absolute right-4 top-4 rounded-full bg-gold px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-ink backdrop-blur">
          {afterLabel}
        </span>
        <div
          className="pointer-events-none absolute inset-y-0 w-[3px] -translate-x-1/2 bg-gold"
          style={{ left: `${v}%` }}
        />
        <div
          className="pointer-events-none absolute top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-4 border-cream bg-gold text-ink shadow-lg"
          style={{ left: `${v}%` }}
        >
          <ChevronsLeftRight size={18} />
        </div>
        <input
          type="range"
          min="2"
          max="98"
          value={v}
          data-testid="compare-slider-input"
          aria-label={`Compare ${beforeLabel} and ${afterLabel}`}
          onChange={(e) => setV(Number(e.target.value))}
          className="compare-range absolute inset-0 h-full w-full opacity-0"
        />
      </div>
      <p className="mt-4 text-center font-mono text-[11px] uppercase tracking-[0.25em] text-stone2">
        Drag to compare
      </p>
    </div>
  );
}
